import { render, staticRenderFns } from "./OperationTypeUpdateContainer.vue?vue&type=template&id=15630cd4"
import script from "./OperationTypeUpdateContainer.vue?vue&type=script&lang=js"
export * from "./OperationTypeUpdateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports